module.exports = __webpack_public_path__ + "static/media/CardCompBlue.df047a01.png";